import { Injectable } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';

import { HotelResultData, ImageResultData, TripDataHours, TripWeekRange, TripTime, YelpDataHours, YelpDataHoursOpen } from '@hiptraveler/data-access/api';
import { ItineraryState } from '@hiptraveler/data-access/itinerary';
import { HourDetails } from './hour-details.interface';

@Injectable()
export class HourDetailsService {

  @Select(ItineraryState.imageInformation) imageInformation$: Observable<ImageResultData>;
  @Select(ItineraryState.hotelInformation) hotelInformation$: Observable<HotelResultData>;

  subscription$: Subject<void> = new Subject<void>();

  mapHoursToModel(imageInformation: ImageResultData): HourDetails[] {
    const hourDetails: HourDetails[] = [];

    if (imageInformation.yelpData?.hours?.length) {
      hourDetails.push(...this.mapYelpHours(imageInformation.yelpData.hours));
    }
    else if (imageInformation.taDataMap?.hours) {
      hourDetails.push(...this.mapTripAdvisorHours(imageInformation.taDataMap.hours));
    }

    return hourDetails;
  }

  mapHotelHours(hotelInformation: HotelResultData): HourDetails[] {
    const hourDetails: HourDetails[] = [];
   
    if (hotelInformation?.taDataMap?.hours) {
      hourDetails.push(...this.mapTripAdvisorHours(hotelInformation.taDataMap.hours));
    }
    
    return hourDetails;
  }

  hasHours(imageInformation: ImageResultData): boolean {
    return !!(
      imageInformation?.yelpData?.hours?.length ||
      imageInformation?.taDataMap?.hours
    );
  }

  hasHotelHours(hotelInformation: HotelResultData): boolean {
    return !!hotelInformation?.taDataMap?.hours;
  }

  private mapYelpHours(yelpHours: YelpDataHours[]): HourDetails[] {
    const hourDetails: HourDetails[] = [];
    
    yelpHours.forEach((hourGroup: YelpDataHours) => {
      hourGroup.open.forEach((openTime: YelpDataHoursOpen) => {
        hourDetails.push({
          day: openTime.day,
          start: openTime.start,
          end: openTime.end
        });
      });
    });
    
    return hourDetails;
  }

  private mapTripAdvisorHours(tripAdvisorHours: TripDataHours): HourDetails[] {
    const hourDetails: HourDetails[] = [];
    
    tripAdvisorHours.week_ranges.forEach((weekRange: TripWeekRange) => {
      weekRange.times.forEach((time: TripTime) => {
        hourDetails.push({
          day: this.getDayNumber(weekRange.localized_day_name),
          start: time.open_time,
          end: time.close_time
        });
      });
    });
    
    return hourDetails;
  }

  private getDayNumber(dayName: string): number {
    const dayMap: { [key: string]: number } = {
      'Sunday': 0,
      'Monday': 1,
      'Tuesday': 2,
      'Wednesday': 3,
      'Thursday': 4,
      'Friday': 5,
      'Saturday': 6
    };
    return dayMap[dayName] ?? 0;
  }
}
